import { DriverTableDTO } from '../../../../../Domain/DTO/DriverTableDTO';

export class SelectDriverHelperProps{
    DriverList: Array<DriverTableDTO>
    SelectedDriver: DriverTableDTO
}

export const InitialSelectDriverHelperProps: SelectDriverHelperProps = <SelectDriverHelperProps>{ 
    DriverList: []
};